import { type InternalAxiosRequestConfig } from 'axios';
import md5 from 'md5';

import { useAppStateRaw } from '@/shared/store/app-store/app-store';

const SEC_HEADER_NAME = 'Security-Ch-Ua-SigHash';
const LOCALE_HEADER_NAME = 'X-Locale';

export const addSecHeader = (request: InternalAxiosRequestConfig) => {
  const { method, url } = request;

  let contentLen = 0;
  const requestMethod = String(method).toUpperCase();

  if (request.data) {
    contentLen = JSON.stringify(request.data).length;
  }

  const path = url![0] === '/' ? url : `/${url}`;
  const hashString = `${requestMethod}+/api${path}+${contentLen}`;
  const hash = md5(hashString);
  request.headers.set(SEC_HEADER_NAME, hash);

  request.headers.set(LOCALE_HEADER_NAME, useAppStateRaw.getState().lang);

  const token = useAppStateRaw.getState().token;

  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`);
  }

  return request;
};
